import { CapitalActionEntryType } from 'further-types/lp/capital-action';
import { UpdateCapitalActionFormValues } from './useCapitalActionForm';
import { pluralize } from 'further-ui/utils';

const entryTypesTitles = {
  [CapitalActionEntryType.Expense]: 'Expense',
  [CapitalActionEntryType.Investment]: 'Investment',
  [CapitalActionEntryType.Fees]: 'Fees',
  [CapitalActionEntryType.GeneralCapitalCall]: 'General capital call',
  [CapitalActionEntryType.AdvanceSubscriptionPayment]:
    'Advance subscription payment',
  [CapitalActionEntryType.CapitalContributionCall]: 'Capital contribution call',
  [CapitalActionEntryType.CapitalRefund]: 'Return of capital',
  [CapitalActionEntryType.CapitalDistribution]: 'Distribution',
  [CapitalActionEntryType.Equalisation]: 'Equalisation',
};

export default function useGetEntryTitle() {
  const getEntryTitle = (
    entry: NonNullable<UpdateCapitalActionFormValues['entries']>[number],
  ) => {
    if (
      [
        CapitalActionEntryType.GeneralCapitalCall,
        CapitalActionEntryType.AdvanceSubscriptionPayment,
        CapitalActionEntryType.CapitalContributionCall,
        CapitalActionEntryType.CapitalRefund,
        CapitalActionEntryType.CapitalDistribution,
      ].includes(entry.entryType)
    ) {
      return `Capital call - ${entryTypesTitles[entry.entryType]}`;
    }

    return `Capital call - ${entryTypesTitles[entry.entryType]} (${
      entry.actions.length
    } ${pluralize('transaction', entry.actions.length)})`;
  };

  return getEntryTitle;
}
